import { NaturalPersonInit, naturalPersonSchema } from './natural-person.type'
import { z } from 'zod'
import { SystemMessages } from 'utils/enums/system-message.enum'
import { addCustomIssue } from 'utils/schema.util'
import { doNotHasText, isCnj } from 'utils/validate.util'
import { ERROR_MESSAGE_CNJ_INCORRECT } from './error.type'

export const SocioeducationMeasureCreateSchema = z
  .object({
    numeroCnj: z.string().nullish(),
    numeroCnjIsValid: z.boolean().nullish(),
    creasId: z.number().nullish(),
  })
  .superRefine((fields, ctx) => {
    const addIssue = (field: string, message: string) => addCustomIssue(ctx, [field], message)

    if (!isCnj(fields.numeroCnj)) {
      addIssue('numeroCnj', ERROR_MESSAGE_CNJ_INCORRECT)
    }

    if (fields.numeroCnjIsValid) {
      if (!fields.creasId || fields.creasId < 1) {
        addIssue('creasId', SystemMessages.MESSAGE_002)
      }
    }
  })

export const SocioeducationMeasureIdentificationSchema = z
  .object({
    id: z.number().nullish(),
    pessoaFisica: naturalPersonSchema,
    creas: z
      .object({
        id: z.number().nullish(),
        nome: z.string().nullish(),
      })
      .nullish(),
    religiao: z.string().nullish(),
    temFilhos: z.boolean().nullish(),
    quantidadeFilhos: z.string().nullish(),
    emGestacao: z.boolean().nullish(),
    nomeResponsavelLegal: z.string().nullish(),
  })
  .superRefine((fields, ctx) => {
    const addIssue = (field: string, message: string) => addCustomIssue(ctx, [field], message)
    if (!fields.creas) {
      addIssue('creas', SystemMessages.MESSAGE_002)
    }
    if (fields.temFilhos && doNotHasText(fields.quantidadeFilhos)) {
      addIssue('quantidadeFilhos', SystemMessages.MESSAGE_002)
    }
  })

export type SocioeducationMeasureIdentificationType = z.infer<
  typeof SocioeducationMeasureIdentificationSchema
>
export type SocioeducationMeasureCreateType = z.infer<typeof SocioeducationMeasureCreateSchema>
export type SocioeducationMeasureCreateResponseType = { id: number }

export const SocioeducationMeasureIdentificationInit: SocioeducationMeasureIdentificationType = {
  pessoaFisica: NaturalPersonInit,
  creas: {},
}

export const SocioeducationMeasureCreateInit: SocioeducationMeasureCreateType = {
  numeroCnj: '',
  creasId: 0,
}
